// Picks black or white for text placed on a solid accent background, using the
// WCAG relative-luminance contrast formula. Any valid hex yields a passing
// black-or-white foreground, so button labels always clear 4.5:1.
export function onAccentTextColor(hex: string): '#000000' | '#ffffff' {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex)
  const hex6 = m?.[1]
  if (!hex6) return '#ffffff'
  const n = parseInt(hex6, 16)
  const channel = (c: number): number => {
    const s = c / 255
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4
  }
  const r = channel((n >> 16) & 255)
  const g = channel((n >> 8) & 255)
  const b = channel(n & 255)
  const L = 0.2126 * r + 0.7152 * g + 0.0722 * b
  const contrastWhite = 1.05 / (L + 0.05)
  const contrastBlack = (L + 0.05) / 0.05
  return contrastBlack >= contrastWhite ? '#000000' : '#ffffff'
}
